<div id="activity-delete-confirm-modal">
  <div class="body p-1">
    <div class="d-flex justify-content-between">
      <i [class]="'trash-icon ' + icon"></i>
      <i class="ph ph-x px-2 close-icon" (click)="close()"></i>
    </div>

    <p class="title">{{ title | translate }}</p>
    <p class="description">{{ description | translate }}</p>

    <div class="d-flex gap-2 pb-2">
      <div class="col">
        <dk-button
          severity="secondary"
          [label]="cancelBtnLabel | translate"
          (onClick)="close()" />
      </div>
      <div class="col">
        <dk-button
          severity="danger"
          [label]="confirmBtnLabel | translate"
          (onClick)="close(true)" />
      </div>
    </div>
  </div>
</div>
